import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from '../work-order/close/CustomStep';
import PmTicketSignalLevels from './pmTicketSignalLevels';
import CreateTicketRadioGroup from 'ticketComponents/CreateTicketRadioGroup';
import CustomerImpactingRadioGroup from 'ticketComponents/CustomerImpactingRadioGroup';
import TicketComment from 'ticketComponents/TicketComment';

class PmTicketStep extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { workOrderActions, orderCloseDetails, stepConfig, orderId, disabled } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        let existingTicket = null;

        if (orderCloseDetails.getIn(['closeOrderRequest', 'ticketRequests'])) {

            existingTicket = orderCloseDetails
                .getIn(['closeOrderRequest', 'ticketRequests'])
                .find((item) => {
                    return item.get('workType') === 'Maintenance';

                });
        }
        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Maintenance Ticket - ${existingTicket
                    ? 'Yes'
                    : 'No'}`}
                stepConfig={stepConfig}
                stepConfigKey="pmStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="pmTicket">
                <div>
                    <CreateTicketRadioGroup
                        disabled={disabled}
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        orderId={orderId} />

                    <CustomerImpactingRadioGroup
                        disabled={disabled}
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        orderId={orderId} />

                    {existingTicket && <PmTicketSignalLevels
                        existingTicket={existingTicket}
                        orderCloseDetails={orderCloseDetails}
                        orderId={orderId}
                        workOrderActions={workOrderActions}
                    />}

                    <TicketComment
                        disabled={disabled}
                        workType="Maintenance"
                        workOrderActions={workOrderActions}
                        orderCloseDetails={orderCloseDetails}
                        orderId={orderId} />
                </div>
            </CustomStep>
        );

    }
}

PmTicketStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    stepConfig: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool
};

export default PmTicketStep;


// WEBPACK FOOTER //
// ./src/components/ticket/PmTicketStep.js